import axios from "axios";

export const train_model=async()=>{
    return await axios.get(`https://health.neuronai.life/train_model`);
}